import React from 'react';
import { Box, Typography, Container } from '@mui/material';

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        width: "100%",
        backgroundColor: "#141414",
      }}
    >
      <Container
        maxWidth="xl"
        sx={{
          width: "90%",
          margin: "0 auto",
          py: '25px',
          borderTop: '1px solid rgba(255, 255, 255, 0.07)'
        }}
      >
        {/* Copyright */}
        <Typography
          variant='caption'
          sx={{
            color: "#FFFFFF",
            fontSize: '14px',
          }}
        >
          © 2026 AKRBIT SIA. All Rights Reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
